var React = require('react');

function ShieldDollar (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"3","fill":"none"},[React.createElement("path",{"d":"M33,81.11C63,68.83,64,45,64,45V13.85C44.16,11.2,33,2,33,2h0S21.81,11.23,2,13.88V45S3,68.85,33,81.13","key":0}),React.createElement("circle",{"cx":"32.99","cy":"41.33","r":"20.66","key":1}),React.createElement("line",{"x1":"33.03","y1":"29.81","x2":"33.03","y2":"32.8","key":2}),React.createElement("path",{"d":"M33,41.11c-4.11,0-4.1-4.22-4.1-4.22s0-4.09,4.14-4.09,4,3.17,4,3.17","key":3}),React.createElement("path",{"d":"M28.9,46.24s0,3.18,4.05,3.18,4.13-4.09,4.13-4.09,0-4.22-4.09-4.22","key":4}),React.createElement("line",{"x1":"33.03","y1":"49.42","x2":"33.03","y2":"52.41","key":5})]));
}

ShieldDollar.defaultProps = {"className":"svg-shield-dollar","viewBox":"0 0 65.98 83.13","stroke":"#000000"};

module.exports = ShieldDollar;

ShieldDollar.default = ShieldDollar;
